import DateTimeRangePicker from '@features/standardDesign/components/DateTimeRangePicker/index';
import { Controller } from 'react-hook-form';


const FormDateTimeRangePicker = (props: {
  control: any;
  name: string;
  rules?: any;
  fullWidth?: boolean;
  hideAbsoluteTime?: boolean;
}) => {
  const { control, name, rules, fullWidth, hideAbsoluteTime = false } = props;
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <DateTimeRangePicker
          value={value}
          onChange={onChange}
          error={error?.message}
          fullWidth={fullWidth}
          hideAbsoluteTime={hideAbsoluteTime}
        />
      )}
    />
  );
};

export { FormDateTimeRangePicker };
